import {
  FonteDadosProxyParametro,
  FonteDadosProxyParametroBody,
  FonteDadosProxyParametroConfig,
  FonteDadosProxyParametroPath,
  FonteDadosProxyParametroQuery,
  FonteDadosProxyParametroTipo,
} from './fonte-dados-proxy-parametro';
import { HttpParams } from '@angular/common/http';

export abstract class FonteDadosProxyRotaAbstract {
  rota: string;
  private readonly pMetodo: string;
  private pParametrosPath?: FonteDadosProxyParametroPath[] = [];
  private pParametrosQuery?: FonteDadosProxyParametroQuery[] = [];
  private pParametrosBody?: FonteDadosProxyParametroBody[] = [];
  private readonly pTipoResposta?: 'arraybuffer' | 'blob' | 'json' | 'text';

  private readonly configPadrao: FonteDadosProxyParametroConfig = {
    tipo: FonteDadosProxyParametroTipo.TEXTO,
    obrigatorio: false,
  };

  protected constructor(rota: string, metodo?: string, tipoResposta?: 'arraybuffer' | 'blob' | 'json' | 'text') {
    this.rota = rota;
    this.pMetodo = metodo ? metodo : 'GET';
    this.pTipoResposta = tipoResposta ? tipoResposta : 'json';
  }

  private parametrosPathFormatado(): string {
    let parametrosPath = '';
    if (this.pParametrosPath) {
      this.pParametrosPath.sort((a, b) => a.ordem - b.ordem);
      parametrosPath = this.pParametrosPath.map((p) => p.valor).join('/');
    }
    return parametrosPath;
  }

  public path(): string {
    return `${this.rota}/${this.parametrosPathFormatado()}`;
  }

  public query(): HttpParams {
    let params = new HttpParams();
    if (this.parametrosQuery && this.parametrosQuery.length > 0) {
      this.parametrosQuery.forEach((paramQuery) => {
        params = params.append(paramQuery.nome, paramQuery.valor);
      });
    }
    return params;
  }

  get metodo(): string {
    return this.pMetodo;
  }

  public body(): any {
    let params = new HttpParams();
    if (this.parametrosBody && this.parametrosBody.length > 0) {
      this.parametrosBody.forEach((paramBody) => {
        params = params.append(paramBody.nome, paramBody.valor);
      });
    }
    return params;
  }

  public adicionarParametrosPath(...parametros: FonteDadosProxyParametroPath[]) {
    this.pParametrosPath.push(...parametros);
  }

  protected adicionarParametroPath(
    nome: string,
    rotulo: string,
    ordem: number,
    config?: FonteDadosProxyParametroConfig
  ): FonteDadosProxyParametroQuery {
    const configParam = { ...this.configPadrao, ...config };

    const parametro = new FonteDadosProxyParametroPath(nome, ordem, config.obrigatorio);
    this.configurarParametro(parametro, rotulo, configParam);
    this.adicionarParametrosPath(parametro);

    return parametro;
  }

  public adicionarParametrosQuery(...parametros: FonteDadosProxyParametroQuery[]) {
    this.pParametrosQuery.push(...parametros);
  }

  protected adicionarParametroQuery(
    nome: string,
    rotulo: string,
    config?: FonteDadosProxyParametroConfig
  ): FonteDadosProxyParametroQuery {
    const configParam = { ...this.configPadrao, ...config };

    const parametro = new FonteDadosProxyParametroQuery(nome, configParam.obrigatorio);
    this.configurarParametro(parametro, rotulo, configParam);
    this.adicionarParametrosQuery(parametro);

    return parametro;
  }

  public adicionarParametroBody(parametro: FonteDadosProxyParametroBody) {
    this.pParametrosBody.push(parametro);
  }

  private configurarParametro(parametro: FonteDadosProxyParametro, rotulo: string, config: FonteDadosProxyParametroConfig) {
    parametro.rotulo = rotulo;
    parametro.titulo = config.titulo ? config.titulo : rotulo;
    parametro.tipo = config.tipo;
    parametro.valor = config.valor;
  }

  public limparValores() {
    this.pParametrosPath.forEach((pp) => (pp.valor = null));
    this.pParametrosQuery.forEach((pq) => (pq.valor = null));
    this.pParametrosBody.forEach((pb) => (pb.valor = null));
  }

  get parametrosQuery(): FonteDadosProxyParametroQuery[] {
    return this.pParametrosQuery;
  }

  get parametrosPath(): FonteDadosProxyParametroPath[] {
    return this.pParametrosPath;
  }

  get parametrosBody(): FonteDadosProxyParametroBody[] {
    return this.pParametrosBody;
  }

  get parametros(): FonteDadosProxyParametro[] {
    return [].concat(this.pParametrosPath, this.pParametrosBody, this.pParametrosQuery);
  }

  get tipoResposta() {
    return this.pTipoResposta;
  }
}
